import { StatesClasses } from './grid.constants';

export const enum FindingsTagStates {
  Cat1Major = 'CAT1 (Major)',
  Cat2Minor = 'CAT2 (Minor)',
  Observation = 'Observation',
  NoteWorthyEffort = 'Noteworthy Effort',
  OpportunityForImprovement = 'Opportunity for Improvement',
  CriticalFood = 'Critical (Food)',
  CategoryAPec = 'Category A (PEC)',
  GeneralPC = 'General (PC)',
  InspectionFindingPC = 'Inspection finding (PC)',
  MissingDocumentationPC = 'Missing documentation (PC)',
  TestFailedPC = 'Test failed (PC)',
  CategoryBPec = 'Category B (PEC)',
  CategoryCPec = 'Category C (PEC)',
  RiskOfNonConformance = 'Risk of non-conformance',
  CriticalNonConformity = 'Critical non-conformity',
  TimeBoundNonConformity = 'Time bound non-conformity',
}

export const FINDINGS_TAG_STATES_MAP: Record<string, string> = {
  [FindingsTagStates.Cat1Major]: StatesClasses.MistyRose,
  [FindingsTagStates.Cat2Minor]: StatesClasses.LightYellow,
  [FindingsTagStates.Observation]: StatesClasses.LightCyan,
  [FindingsTagStates.NoteWorthyEffort]: StatesClasses.PastelGreen,
  [FindingsTagStates.OpportunityForImprovement]: StatesClasses.PeachPuff,
  [FindingsTagStates.CriticalFood]: StatesClasses.MistyRose,
  [FindingsTagStates.CategoryAPec]: StatesClasses.MistyRose,
  [FindingsTagStates.GeneralPC]: StatesClasses.LightYellow,
  [FindingsTagStates.InspectionFindingPC]: StatesClasses.LightYellow,
  [FindingsTagStates.MissingDocumentationPC]: StatesClasses.LightCyan,
  [FindingsTagStates.TestFailedPC]: StatesClasses.LightYellow,
  [FindingsTagStates.CategoryBPec]: StatesClasses.LightYellow,
  [FindingsTagStates.CategoryCPec]: StatesClasses.LightCyan,
  [FindingsTagStates.RiskOfNonConformance]: StatesClasses.LightCyan,
  [FindingsTagStates.CriticalNonConformity]: StatesClasses.MistyRose,
  [FindingsTagStates.TimeBoundNonConformity]: StatesClasses.MistyRose,
};

export const enum FindingsStatusStates {
  Open = 'Open',
  Accepted = 'Accepted',
  Closed = 'Closed',
  Responded = 'Responded',
  Reverted = 'Reverted',
  NoAction = 'No Action',
}

export const FINDINGS_STATUS_STATES_MAP: Record<string, string> = {
  [FindingsStatusStates.Open.toLowerCase()]: StatesClasses.SunflowerYellow,
  [FindingsStatusStates.Accepted.toLowerCase()]: StatesClasses.FernGreen,
  [FindingsStatusStates.Closed.toLowerCase()]: StatesClasses.AshGrey,
  [FindingsStatusStates.Responded.toLowerCase()]: StatesClasses.SummerSky,
  [FindingsStatusStates.Reverted.toLowerCase()]: StatesClasses.CrimsonFlame,
};

export const FINDINGS_STATUS_COLOR_MAPPING: Record<string, string> = {
  [FindingsStatusStates.Open]: '#FFF377',
  [FindingsStatusStates.Responded]: '#99D9F0',
  [FindingsStatusStates.Accepted]: '#65B05D',
  [FindingsStatusStates.Closed]: '#CBCAC8',
  [FindingsStatusStates.Reverted]: '#D3262F',
  'No Action': '#000000',
};

export const FINDINGS_CLOSED_SELECTED_COLOR = '#9C9A96';
